// react-frontend/src/admin/bookings/CompletedBookings.js
import React from 'react';
import AllBookings from './AllBookings';

const CompletedBookings = () => {
  return <AllBookings defaultTab="completed" />;
};

export default CompletedBookings;